var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7258 7.75954C16.3611 8.22644 16.3611 9.17552 15.7258 9.64242C14.675 10.4149 14.1404 11.7106 14.3374 12.9998C14.4569 13.7816 13.7811 14.4574 12.9993 14.3379C11.7101 14.1409 10.4144 14.6755 9.64193 15.7263C9.17503 16.3615 8.22595 16.3615 7.75906 15.7263C6.98662 14.6755 5.69085 14.1409 4.4016 14.3379C3.61979 14.4574 2.94414 13.7816 3.06358 12.9998C3.26055 11.7106 2.72601 10.4149 1.67514 9.64242C1.03993 9.17552 1.03993 8.22644 1.67514 7.75954C2.72601 6.9871 3.26055 5.69134 3.06358 4.40209C2.94414 3.62028 3.61979 2.94462 4.4016 3.06406C5.69085 3.26104 6.98662 2.7265 7.75906 1.67562C8.22595 1.04042 9.17503 1.04042 9.64193 1.67562C10.4144 2.7265 11.7101 3.26104 12.9993 3.06406C13.7811 2.94462 14.4569 3.62028 14.3374 4.40209C14.1404 5.69134 14.675 6.9871 15.7258 7.75954Z",
    stroke: "black",
    strokeWidth: 1.24236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70053 11.7702C10.6651 11.7702 11.7702 10.6651 11.7702 8.70053C11.7702 6.73594 10.6651 5.63086 8.70053 5.63086C6.73595 5.63086 5.63086 6.73594 5.63086 8.70053C5.63086 10.6651 6.73595 11.7702 8.70053 11.7702Z",
    stroke: "black",
    strokeWidth: 1.24236,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.74675fd517fb0bac50d54de1c2939538.svg";
export { ForwardRef as ReactComponent };